// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f11c4ce4","121":"54bfae75","139":"66ba59bb","170":"0560e723","307":"0d6cbb4a","453":"f0d5df9f","581":"587f62d9","596":"1cbfeb4b","619":"07f79749","669":"781cce30","881":"085dff68","924":"5c8fcf5b"}[chunkId] + ".chunk.js";
};